import { cn, dynamicStyling } from 'styles';

import { slicePage } from './utils';

import { useTable } from './Table';
import { tableStyleConfig } from './styles';
import { TableRow } from './Row';

export function TableBody() {
  const {
    items,
    uniqueKey,
    columns,
    dataClassName: globalDataClassName,
    cellClassName,
    page,
    itemsPerPage,
    spacing,
  } = useTable();

  return (
    <tbody>
      {slicePage(items, page, itemsPerPage).map((item, index) => (
        <TableRow key={`${item[uniqueKey]}`} className="hover:bg-hover">
          {columns.map(
            (
              { width, dataClassName, className, property, label, render, columnSpan },
              itemIndex,
            ) => (
              <td
                key={`${property ?? (item[uniqueKey] as string)}-action-${label || itemIndex}-${index}`}
                colSpan={columnSpan}
                {...dynamicStyling({
                  width,

                  className: cn(
                    // whitespace-nowrap ?
                    'align-middle text-sm',
                    tableStyleConfig.spacing[spacing],
                    cellClassName,
                    globalDataClassName,
                    className,
                    dataClassName,
                  ),
                })}
              >
                {render?.(item) ?? item[property as string]}
              </td>
            ),
          )}
        </TableRow>
      ))}
    </tbody>
  );
}
